import { ORDER_BY } from 'constants/paginationOrder';
import { MOBILE_PAGE, MOBILE_SIZE } from 'constants/values/params';
import {
  SET_GIFT_SEARCH_VALUES,
  FETCH_GIFTS_TABLES,
  FETCH_GIFTS_TABLES_SUCCESS,
  FETCH_GIFTS_TABLES_FAILED,
  FETCH_MY_GIFTS_TABLES,
  FETCH_MY_GIFTS_TABLES_SUCCESS,
  FETCH_MY_GIFTS_TABLES_FAILED,
  FETCH_GIFT_TABLE_INFO,
  FETCH_GIFT_TABLE_INFO_SUCCESS,
  FETCH_GIFT_TABLE_INFO_FAILED,
  FETCH_RECEIVED_GIFTS,
  FETCH_RECEIVED_GIFTS_SUCCESS,
  FETCH_RECEIVED_GIFTS_FAILED,
  SET_TABLE_INFO,
  FETCH_GIFT_TABLE_PRODUCTS,
  FETCH_GIFT_TABLE_PRODUCTS_SUCCESS,
  FETCH_GIFT_TABLE_PRODUCTS_FAILED,
  CHANGE_GIFT_TABLE_PRODUCTS_PAGE,
  ADD_PRODUCT,
  DELETE_PRODUCT,
  CHANGE_GIFT_TABLE_PRODUCTS_SORT,
  DELETE_GIFT_TABLE,
  DELETE_GIFT_TABLE_SUCCESS,
  DELETE_GIFT_TABLE_FAILED,
  UPDATE_GIFT_TABLE,
  UPDATE_GIFT_TABLE_SUCCESS,
  UPDATE_GIFT_TABLE_FAILED,
  SET_GIFT_TABLE,
  REMOVE_GIFT_TABLE,
  REDIRECT_AND_RESET,
  FETCH_ELECTRONIC_TABLE_INFO,
  FETCH_ELECTRONIC_TABLE_INFO_SUCCESS,
  FETCH_ELECTRONIC_TABLE_INFO_FAILED,
} from 'store/actions/giftTable/types';

export const initialState = {
  giftTableSearchValues: {},
  listOfGiftsTables: {
    params: {
      page: 1,
      size: 10,
      orderBy: ORDER_BY.ASC,
    },
    totalPages: 1,
    totalElements: 10,
    results: {
      list: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    },
  },
  myListOfGiftsTables: {
    params: {
      page: 1,
      size: 10,
      orderBy: ORDER_BY.ASC,
    },
    totalPages: 1,
    totalElements: 10,
    results: {
      list: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    },
  },
  listOfReceivedGifts: {
    params: {
      page: 1,
      size: 10,
      orderBy: ORDER_BY.ASC,
    },
    totalPages: 1,
    totalElements: 10,
    results: {
      list: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    },
  },
  giftTableInfo: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  electronicWalletInfo: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: {},
  },
  giftTableProducts: {
    params: {
      page: 1,
      size: 12,
      mobilePage: MOBILE_PAGE,
      mobileSize: MOBILE_SIZE,
    },
    totalPages: 1,
    totalElements: 10,
    results: {
      list: [],
      mobileList: [],
      allElements: [],
      loading: false,
      success: false,
      error: false,
      errorMessage: '',
    },
  },
  deleteGiftTable: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: [],
  },
  updateGiftTable: {
    success: false,
    loading: false,
    error: false,
    errorMessage: '',
    data: [],
  },
  giftTable: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GIFT_SEARCH_VALUES:
      return {
        ...state,
        giftTableSearchValues: {
          ...state.giftTableSearchValues,
          ...action.payload,
        },
      };
    case FETCH_GIFTS_TABLES:
      return {
        ...state,
        listOfGiftsTables: {
          ...state.listOfGiftsTables,
          totalPages: 1,
          totalElements: 10,
          results: {
            ...state.listOfGiftsTables.results,
            list: [],
            loading: false,
            success: false,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_GIFTS_TABLES_SUCCESS:
      return {
        ...state,
        listOfGiftsTables: {
          ...state.listOfGiftsTables,
          params: {
            ...state.listOfGiftsTables.params,
            ...action.payload.params,
          },
          totalPages:
            action.payload.totalPages || state.listOfGiftsTables.totalPages,
          totalElements:
            action.payload.totalElements || state.listOfGiftsTables.totalPages,
          results: {
            ...state.listOfGiftsTables.results,
            list: action.payload.list,
            loading: false,
            success: true,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_GIFTS_TABLES_FAILED:
      return {
        ...state,
        listOfGiftsTables: {
          ...state.listOfGiftsTables,
          results: {
            ...state.listOfGiftsTables.results,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload,
          },
        },
      };
    case FETCH_MY_GIFTS_TABLES:
      return {
        ...state,
        myListOfGiftsTables: {
          ...state.myListOfGiftsTables,
          results: {
            ...state.myListOfGiftsTables.results,
            loading: false,
            success: false,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_MY_GIFTS_TABLES_SUCCESS:
      return {
        ...state,
        myListOfGiftsTables: {
          ...state.myListOfGiftsTables,
          params: {
            ...state.myListOfGiftsTables.params,
            ...action.payload.params,
          },
          totalPages:
            action.payload.totalPages || state.myListOfGiftsTables.totalPages,
          totalElements:
            action.payload.totalElements ||
            state.myListOfGiftsTables.totalPages,
          results: {
            ...state.myListOfGiftsTables.results,
            list: action.payload.list,
            loading: false,
            success: true,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_MY_GIFTS_TABLES_FAILED:
      return {
        ...state,
        myListOfGiftsTables: {
          ...state.myListOfGiftsTables,
          results: {
            ...state.myListOfGiftsTables.results,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload,
          },
        },
      };
    case FETCH_RECEIVED_GIFTS:
      return {
        ...state,
        listOfReceivedGifts: {
          ...state.listOfReceivedGifts,
          results: {
            ...state.listOfReceivedGifts.results,
            loading: false,
            success: false,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_RECEIVED_GIFTS_SUCCESS:
      return {
        ...state,
        listOfReceivedGifts: {
          ...state.listOfReceivedGifts,
          params: {
            ...state.listOfReceivedGifts.params,
            ...action.payload.params,
          },
          totalPages:
            action.payload.totalPages || state.listOfReceivedGifts.totalPages,
          totalElements:
            action.payload.totalElements ||
            state.listOfReceivedGifts.totalPages,
          results: {
            ...state.listOfReceivedGifts.results,
            list: action.payload.list,
            loading: false,
            success: true,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_RECEIVED_GIFTS_FAILED:
      return {
        ...state,
        listOfReceivedGifts: {
          ...state.listOfReceivedGifts,
          results: {
            ...state.listOfReceivedGifts.results,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload,
          },
        },
      };

    case FETCH_GIFT_TABLE_INFO:
      return {
        ...state,
        giftTableInfo: {
          ...initialState.giftTableInfo,
          loading: true,
        },
      };
    case FETCH_GIFT_TABLE_INFO_SUCCESS:
      return {
        ...state,
        giftTableInfo: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
      };
    case SET_TABLE_INFO:
      return {
        ...state,
        giftTableInfo: {
          ...state.giftTableInfo,
          data: { ...state.giftTableInfo.data, ...action.payload },
        },
      };
    case FETCH_GIFT_TABLE_INFO_FAILED:
      return {
        ...state,
        giftTableInfo: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.giftTableInfo.data,
        },
      };

    case FETCH_ELECTRONIC_TABLE_INFO:
      return {
        ...state,
        electronicWalletInfo: {
          ...initialState.electronicWalletInfo,
          loading: true,
        },
      };
    case FETCH_ELECTRONIC_TABLE_INFO_SUCCESS:
      return {
        ...state,
        electronicWalletInfo: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
      };
    case FETCH_ELECTRONIC_TABLE_INFO_FAILED:
      return {
        ...state,
        electronicWalletInfo: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.giftTableInfo.data,
        },
      };
    case FETCH_GIFT_TABLE_PRODUCTS:
      return {
        ...state,
        giftTableProducts: {
          ...state.giftTableProducts,
          results: {
            ...state.giftTableProducts.results,
            loading: true,
            success: false,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_GIFT_TABLE_PRODUCTS_SUCCESS:
      return {
        ...state,
        giftTableProducts: {
          ...state.giftTableProducts,
          params: {
            ...state.giftTableProducts.params,
            ...action.payload.params,
          },
          totalPages:
            action.payload.totalPages || state.giftTableProducts.totalPages,
          totalElements:
            action.payload.totalElements || state.giftTableProducts.totalPages,
          results: {
            ...state.giftTableProducts.results,
            list: action.payload.list,
            mobileList: action.payload.mobileList,
            allElements: action.payload.allElements,
            loading: false,
            success: true,
            error: false,
            errorMessage: '',
          },
        },
      };
    case FETCH_GIFT_TABLE_PRODUCTS_FAILED:
      return {
        ...state,
        giftTableProducts: {
          ...state.giftTableProducts,
          results: {
            ...state.giftTableProducts.results,
            loading: false,
            success: false,
            error: true,
            errorMessage: action.payload,
          },
        },
      };
    case CHANGE_GIFT_TABLE_PRODUCTS_PAGE:
      return {
        ...state,
        giftTableProducts: {
          ...state.giftTableProducts,
          params: {
            ...state.giftTableProducts.params,
            ...action.payload.params,
          },
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          results: {
            ...state.giftTableProducts.results,
            list: action.payload.list,
            mobileList: action.payload.mobileList,
            allElements:
              action.payload.allElements ||
              state.giftTableProducts.results.allElements,
          },
        },
      };
    case ADD_PRODUCT:
    case CHANGE_GIFT_TABLE_PRODUCTS_SORT:
      return {
        ...state,
        giftTableProducts: {
          ...state.giftTableProducts,
          results: {
            ...state.giftTableProducts.results,
            ...action.payload.list,
          },
        },
      };
    case DELETE_PRODUCT:
      return {
        ...state,
        giftTableProducts: {
          ...state.giftTableProducts,
          results: {
            ...state.giftTableProducts.results,
            allElements: action.payload.allElements,
            list: action.payload.list,
            mobileList: action.payload.list,
          },
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
        },
      };
    case DELETE_GIFT_TABLE:
      return {
        ...state,
        deleteGiftTable: {
          ...initialState.deleteGiftTable,
          loading: true,
        },
      };
    case DELETE_GIFT_TABLE_SUCCESS:
      return {
        ...state,
        deleteGiftTable: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
      };
    case DELETE_GIFT_TABLE_FAILED:
      return {
        ...state,
        deleteGiftTable: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.deleteGiftTable.data,
        },
      };
    case UPDATE_GIFT_TABLE:
      return {
        ...state,
        updateGiftTable: {
          ...initialState.updateGiftTable,
          loading: true,
        },
      };
    case UPDATE_GIFT_TABLE_SUCCESS:
      return {
        ...state,
        updateGiftTable: {
          success: true,
          loading: false,
          error: false,
          errorMessage: '',
          data: action.payload,
        },
        giftTableInfo: {
          ...state.giftTableInfo,
          data: {
            ...state.giftTableInfo.data,
            ...action.payload,
          },
        },
      };
    case UPDATE_GIFT_TABLE_FAILED:
      return {
        ...state,
        updateGiftTable: {
          success: false,
          loading: false,
          error: true,
          errorMessage: action.payload,
          data: initialState.updateGiftTable.data,
        },
      };
    case SET_GIFT_TABLE:
      return {
        ...state,
        giftTable: action.payload,
      };
    case REMOVE_GIFT_TABLE:
      return {
        ...state,
        giftTable: initialState.giftTable,
      };
    case REDIRECT_AND_RESET:
      return initialState;
    default:
      return state;
  }
};
